import { SET_THEME } from "../types";

// Check token & load user
export const setTheme = (type) => (dispatch) => {
  dispatch({
    type: SET_THEME,
    payload: type,
  });
};
